import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function JustifyAndAlign({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"Default"} value={""}>
          Default
        </MenuItem>,
        ["center", "start", "space-around", "space-between", "evenly", "flex-end"].map((fontName) => {
          return (
            <MenuItem key={fontName} value={fontName}>
              {fontName}
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSJustifyAndAlignComponent: JSInputComponent = {
  Component: JustifyAndAlign,
  handlesCssProperties: ["justifyContent", "alignItems", "justifyItems", "alignContent"],
};
